import React from "react";
import AutoComplete from "react-autocomplete";

export default function SearchDownShift({
  items,
  name,
  setName,
  placeHolder,
  setId,
}) {
  // const [name, setName] = React.useState("");
  const handelChange = (e) => {
    setName(e?.target?.value);
  };
  const handelSelect = (name, item) => {
    setName(name);
    if (setId) {
      setId(item.id);
    }
  };

  return (
    <div className="down-shift search-wrapper search-down-shift">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#ACACAC"
          class="bi bi-search"
          viewBox="0 0 16 16"
        >
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
        </svg>
      </span>
      <AutoComplete
        id="id1"
        getItemValue={(item) => item?.name}
        items={items?.filter((member) =>
          member?.name?.toLowerCase().includes(name.toLowerCase())
        )}
        renderItem={(item, isHighlighted) => (
          <div
            id="id2"
            className="search-down-shift-options"
            style={{
              verticalAlign: "middle",
            }}
          >
            <div style={{ display: "inline-block", minWidth: 200 }}>
              {item?.name}
            </div>
          </div>
        )}
        wrapperStyle={{
          position: "relative",
        }}
        menuStyle={{
          display: items?.length ? "block" : "none",
          backgroundColor: "#FFF",
          border: "1px solid #B5B5C3",
          zIndex: 999,
          position: "absolute",
          top: 45,
          left: 0,
          overflow: "auto",
          maxHeight: 150,
        }}
        value={name || ""}
        inputProps={{
          id: "down-shift__input",
          placeholder: placeHolder,
        }}
        onChange={handelChange}
        onSelect={(name, item) => handelSelect(name, item)}
      />
    </div>
  );
}
